import { render, staticRenderFns } from "./StatisticsMultiCard.vue?vue&type=template&id=4e36fa94"
import script from "./StatisticsMultiCard.vue?vue&type=script&lang=js"
export * from "./StatisticsMultiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports